import EventsCollection from '@components/eventsCollection/EventsCollection'
import { Localizable } from '@components/localizable/Localizable'
import Page from '@components/Page/Page'
import { SBRM, SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Flex, Space } from 'antd'

const EventsCollectionPage = () => {
  return (
    <Localizable>
      <Page
        pageTitle={{
          title: 'Collections',
          level: 5,
          toolbar: (
            <Space>
              <Localizable.LangSelector />
              <SBRM.Actions
                actions={[SBRMAction.Create]}
                entity={Entity.eventsCollection}
              />
            </Space>
          ),
        }}
      >
        <Flex vertical gap={32}>
          <EventsCollection.Card />
        </Flex>
      </Page>
    </Localizable>
  )
}

export default EventsCollectionPage
